import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import config from 'configs/app';
import RewardsButton from 'ui/rewards/RewardsButton';
import SearchBar from 'ui/snippets/searchBar/SearchBar';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

const HeroBanner = () => {

  return (
    <Box
      w="100%"
      position="relative"
      overflow="hidden"
      borderRadius="2xl"
      boxShadow="0 20px 60px rgba(37, 99, 235, 0.25)"
      mx="auto"
      maxW="100%"
      style={{
        background: 'linear-gradient(135deg, #0F172A 0%, #1E3A8A 30%, #1D4ED8 60%, #2563EB 100%)',
      }}
    >
      {/* Decorative circles */}
      <Box
        position="absolute"
        top="-80px"
        right="-80px"
        w="400px"
        h="400px"
        borderRadius="full"
        style={{ background: 'rgba(255,255,255,0.05)' }}
        pointerEvents="none"
      />
      <Box
        position="absolute"
        bottom="-100px"
        left="30%"
        w="350px"
        h="350px"
        borderRadius="full"
        style={{ background: 'rgba(255,255,255,0.04)' }}
        pointerEvents="none"
      />
      <Box
        position="absolute"
        top="20px"
        left="-60px"
        w="250px"
        h="250px"
        borderRadius="full"
        style={{ background: 'rgba(255,255,255,0.03)' }}
        pointerEvents="none"
      />

      { /* Dot grid pattern - modern tech look */ }
      <Box
        position="absolute"
        inset={ 0 }
        opacity={ 0.15 }
        pointerEvents="none"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />
      { /* Glow accent bottom right */ }
      <Box
        position="absolute"
        bottom="-60px"
        right="-60px"
        w="300px"
        h="300px"
        borderRadius="full"
        pointerEvents="none"
        style={{
          background: 'radial-gradient(circle, rgba(96,165,250,0.3) 0%, transparent 70%)',
        }}
      />

      <Flex
        position="relative"
        zIndex={1}
        flexDirection="column"
        px={{ base: 6, md: 10, lg: 16 }}
        py={{ base: 10, lg: 14 }}
        gap={8}
      >
        {/* Top row: title + buttons */}
        <Flex justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={4}>
          <Box maxW={{ base: '100%', lg: '70%' }}>
            {/* Badge */}
            <Box
              display="inline-flex"
              alignItems="center"
              style={{
                background: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.2)',
              }}
              borderRadius="full"
              px={4}
              py={1.5}
              mb={4}
            >
              <Box
                w={2}
                h={2}
                borderRadius="full"
                style={{ background: '#93C5FD' }}
                mr={2}
                flexShrink={0}
              />
              <Text
                fontSize="xs"
                fontWeight={600}
                color="white"
                letterSpacing="0.08em"
                textTransform="uppercase"
              >
                VietChain Blockchain Explorer
              </Text>
            </Box>

            {/* Main heading */}
            <Heading
              as="h1"
              fontSize={{ base: '3xl', md: '4xl', lg: '6xl' }}
              lineHeight={1.1}
              fontWeight={800}
              color="white"
              letterSpacing="-0.02em"
            >
              Explore the{' '}
              <Box
                as="span"
                style={{
                  background: 'linear-gradient(90deg, #93C5FD 0%, #BFDBFE 50%, #E0F2FE 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                VietChain
              </Box>
              {' '}Network
            </Heading>

            <Text
              mt={3}
              fontSize={{ base: 'sm', lg: 'md' }}
              color="rgba(255,255,255,0.80)"
              fontWeight={400}
              maxW="520px"
            >
              Search transactions, addresses, blocks and all on-chain data
            </Text>
          </Box>

          {/* Action buttons */}
          {config.UI.navigation.layout === 'vertical' && (
            <Box display={{ base: 'none', lg: 'flex' }} gap={3} alignItems="center">
              {config.features.rewards.isEnabled && <RewardsButton variant="solid"/>}
              {
                (config.features.account.isEnabled && <UserProfileDesktop buttonVariant="solid"/>) ||
                (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop buttonVariant="solid"/>)
              }
            </Box>
          )}
        </Flex>

        {/* Search bar */}
        <Box
          maxW="900px"
          w="100%"
          sx={{
            '& input': {
              background: 'rgba(255,255,255,0.15) !important',
              borderColor: 'rgba(255,255,255,0.3) !important',
              backdropFilter: 'blur(12px)',
              _placeholder: { color: 'rgba(255,255,255,0.6) !important' },
              _focus: {
                borderColor: 'rgba(255,255,255,0.7) !important',
                boxShadow: '0 0 0 3px rgba(255,255,255,0.2) !important',
                background: 'rgba(255,255,255,0.22) !important',
              },
            },
          }}
        >
          <SearchBar isHomepage/>
        </Box>

      </Flex>
    </Box>
  );
};

export default React.memo(HeroBanner);
